import { Route, Routes } from "react-router";
import "./App.css";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Profile } from "./Profile";

export function App() {
  return (
    <>
      <div id="container">
        <div id="pagecontainer">
          <div className="column left">&nbsp;</div>
          <Header />
          <div id="page" style={{ height: "350px" }}>
            <Routes>
              <Route path="/" element={<Profile />} />
              <Route path="profile" element={<Profile />} />
            </Routes>
          </div>
          <Footer />
          <div className="column right">&nbsp;</div>
        </div>
      </div>
    </>
  );
}
